/** True when the URL points at a direct video file (not YouTube). */
export function isVideoMediaUrl(url?: string | null): boolean {
  if (!url?.trim()) {
    return false;
  }

  const lower = url.trim().toLowerCase();
  return ['.mp4', '.webm', '.mov', '.m4v', '.avi', '.mkv'].some((ext) => lower.includes(ext));
}

export type PopupMediaOrientation = 'landscape' | 'portrait' | 'square';

/** Classify natural media dimensions for responsive popup layout. */
export function getPopupMediaOrientation(width: number, height: number): PopupMediaOrientation {
  if (!width || !height) {
    return 'square';
  }

  const ratio = width / height;
  if (ratio > 1.12) {
    return 'landscape';
  }
  if (ratio < 0.88) {
    return 'portrait';
  }
  return 'square';
}
